import React from "react";
import PropTypes from "prop-types";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

// Custom styles for the LoaderDialogBox component
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1, // Ensures the loader appears above other elements
    color: "#fff", // Text color
    backgroundColor: "transparent", // Transparent background
  },
}));

// Functional component for displaying a loading spinner in a dialog box
function LoaderDialogBox(props) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={props.loader}>
      <CircularProgress
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "3%", // Adjust width as needed
          zIndex: 1300, // Ensures the spinner is above other elements
          display: "flex",
          marginTop: "23%", // Adjust vertical alignment
          marginRight: "23%", // Adjust horizontal alignment
          flexDirection: "column",
          overflowY: "auto", // Allows scrolling if content overflows
          color: "#3956a6", // Spinner color
        }}
        color="inherit"
      />
    </Backdrop>
  );
}

// Prop type validation for the loader prop
LoaderDialogBox.propTypes = {
  loader: PropTypes.bool, // Boolean to control the visibility of the loader
};

// Exporting the LoaderDialogBox component
export default LoaderDialogBox;
